import { render, staticRenderFns } from "./_q.vue?vue&type=template&id=3dc7813e"
import script from "./_q.vue?vue&type=script&lang=js"
export * from "./_q.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports